import { render, staticRenderFns } from "./CadDwgPreview.vue?vue&type=template&id=0808c9a9&scoped=true"
import script from "./CadDwgPreview.vue?vue&type=script&lang=js"
export * from "./CadDwgPreview.vue?vue&type=script&lang=js"
import style0 from "./CadDwgPreview.vue?vue&type=style&index=0&id=0808c9a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0808c9a9",
  null
  
)

export default component.exports